import * as React from "react";
import { forwardRef, memo } from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.99967 14.6666C4.31777 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31777 1.33325 7.99967 1.33325C11.6815 1.33325 14.6663 4.31802 14.6663 7.99992C14.6663 11.6818 11.6815 14.6666 7.99967 14.6666ZM7.33301 7.33325H4.66634V8.66659H7.33301V11.3333H8.66634V8.66659H11.333V7.33325H8.66634V4.66659H7.33301V7.33325Z", fill: "#2F2F2F" }));
const ForwardRef = forwardRef(SvgAdd);
const Memo = memo(ForwardRef);
export default Memo;
